import { useState, useEffect } from "react";
import { X } from "lucide-react";
import api, { resolveImage } from "@/lib/api";

export default function PromoPopup() {
  const [ad, setAd] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try { if (sessionStorage.getItem("ad_dismissed")) return; } catch (e) {}
    api.get("/ad").then((r) => {
      const a = r.data;
      if (a && a.enabled && (a.show_on === "popup" || a.show_on === "abu" || !a.show_on) && (a.title || a.text || a.image_url)) {
        setAd(a);
        setOpen(true);
      }
    }).catch(() => {});
  }, []);

  const close = () => {
    setOpen(false);
    try { sessionStorage.setItem("ad_dismissed", "1"); } catch (e) {}
  };

  if (!open || !ad) return null;

  return (
    <div className="fixed inset-0 z-[100] bg-black/60 flex items-center justify-center p-4" onClick={close} data-testid="promo-popup">
      <div className="bg-white dark:bg-[#111A28] rounded-2xl max-w-md w-full overflow-hidden relative shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <button onClick={close} className="absolute top-3 right-3 z-10 bg-white dark:bg-[#111A28]/90 rounded-full p-1.5 text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white shadow" aria-label="Uždaryti">
          <X size={18} />
        </button>
        {ad.image_url && (
          <img src={resolveImage(ad.image_url)} alt={ad.title || "Reklama"} className="w-full max-h-64 object-cover" />
        )}
        <div className="p-6">
          {ad.title && <h3 className="font-heading text-2xl font-bold text-gray-900 dark:text-gray-100">{ad.title}</h3>}
          {ad.text && <p className="text-gray-600 dark:text-gray-300 mt-2 leading-relaxed whitespace-pre-line">{ad.text}</p>}
          {ad.link_url && (
            <a href={ad.link_url} onClick={close} className="btn-primary mt-5 inline-flex">{ad.button_text || "Sužinoti daugiau"}</a>
          )}
        </div>
      </div>
    </div>
  );
}
